// MRS Studios — Search overlay with predictive results
(function () {
  'use strict';

  var searchEl = document.getElementById('mrs-search');
  var input = document.getElementById('mrs-search-input');
  var results = document.getElementById('mrs-search-results');
  var closeBtn = document.getElementById('mrs-search-close');
  var trigger = document.querySelector('.mrs-header__search-btn');
  var overlay = document.getElementById('mrs-overlay');

  if (!searchEl || !input || !trigger) return;

  var debounceTimer = null;
  var salePct = window.MRS_SALE_PERCENT || 0;

  function open() {
    searchEl.classList.add('open');
    searchEl.setAttribute('aria-hidden', 'false');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { input.focus(); }, 100);
  }

  function close() {
    searchEl.classList.remove('open');
    searchEl.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
    input.value = '';
    results.innerHTML = '';
  }

  trigger.addEventListener('click', open);
  closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', function () {
    if (searchEl.classList.contains('open')) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchEl.classList.contains('open')) close();
    // Cmd/Ctrl+K to open search
    if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
      e.preventDefault();
      if (searchEl.classList.contains('open')) close();
      else open();
    }
  });

  function formatMoney(cents) {
    return '\u00a3' + (cents / 100).toFixed(2);
  }

  function renderResults(data) {
    var products = data.resources && data.resources.results && data.resources.results.products;
    if (!products || !products.length) {
      results.innerHTML = '<div class="mrs-search__empty">No results found</div>';
      return;
    }

    var html = '';
    products.forEach(function (p) {
      var title = p.title.split(' | ')[0];
      // suggest.json gives the price as a decimal string in shop currency ("80.00"), not pence
      // ref: https://shopify.dev/docs/api/ajax/reference/predictive-search
      var price = Math.round(parseFloat(p.price) * 100);
      var img = p.image || '';

      var priceHtml;
      if (salePct > 0) {
        var salePrice = Math.ceil(price * (100 - salePct) / 100);
        priceHtml = '<span style="text-decoration:line-through;margin-right:6px;">' + formatMoney(price) + '</span>';
        priceHtml += '<span style="color:#9b2c2c;">' + formatMoney(salePrice) + '</span>';
      } else {
        priceHtml = formatMoney(price);
      }

      html += '<a href="' + p.url + '" class="mrs-search__item">';
      if (img) {
        html += '<img class="mrs-search__item-img" src="' + img.replace(/(\.\w+)\?/, '$1?width=120&') + '" alt="" width="56" height="75" loading="lazy">';
      }
      html += '<div class="mrs-search__item-info">';
      html += '<p class="mrs-search__item-title">' + title + '</p>';
      html += '<p class="mrs-search__item-price">' + priceHtml + '</p>';
      html += '</div></a>';
    });

    html += '<div class="mrs-search__view-all-wrap">';
    html += '<a href="/search?q=' + encodeURIComponent(input.value) + '&type=product" class="mrs-search__view-all">View All Results</a>';
    html += '</div>';

    results.innerHTML = html;
  }

  function search() {
    var q = input.value.trim();
    if (q.length < 2) {
      results.innerHTML = '';
      return;
    }

    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
      .then(function (r) { return r.json(); })
      .then(renderResults)
      .catch(function () {
        results.innerHTML = '<div class="mrs-search__empty">Something went wrong</div>';
      });
  }

  input.addEventListener('input', function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(search, 300);
  });
})();
